// 現在のページをフッターに伝える
export const display = (page: string) => {
  return {
    type: page,
  };
};
